module.exports = __webpack_public_path__ + "img/banner.f23018cb.png";